var _path, _ellipse, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 205,
    viewBox: "0 0 229 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.386 95.0242C210.538 93.9845 210.642 92.9304 210.642 91.8478C210.642 80.0964 201.34 70.5673 189.85 70.5143C191.305 49.3141 184.964 35.6175 182.919 31.7863C180.819 27.8533 157.547 -5.7548 121.329 0.859485C89.0346 6.75754 71.777 44.1799 68.4134 52.2258C63.7143 49.9134 58.4471 48.6175 52.8845 48.6175C33.1031 48.6175 17.066 65.0013 17.066 85.212C17.066 88.6028 17.5278 91.882 18.3733 94.9997C8.02489 96.2698 0 105.254 0 116.169C0 127.496 8.64487 136.737 19.5589 137.438V137.507H207.446V137.492C207.538 137.493 207.629 137.507 207.722 137.507C219.256 137.507 228.607 127.953 228.607 116.169C228.607 105.308 220.659 96.3627 210.386 95.0242Z",
    fill: "white",
    fillOpacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.194,
    cy: 114.143,
    rx: 58.319,
    ry: 58.319,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.194,
    cy: 114.143,
    r: 82.8395,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.819 183.934C182.819 195.178 150.21 204.292 109.984 204.292C69.7583 204.292 37.1488 195.178 37.1488 183.934C37.1488 172.69 69.7583 163.575 109.984 163.575C150.21 163.575 182.819 172.69 182.819 183.934Z",
    fill: "url(#paint0_radial_1590_3987)",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9187 55.1336C89.9187 55.9811 89.2317 56.668 88.3844 56.668C87.5369 56.668 86.85 55.9811 86.85 55.1336C86.85 54.2863 87.5369 53.5993 88.3844 53.5993C89.2317 53.5993 89.9187 54.2863 89.9187 55.1336Z",
    fill: "#F63032"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.859 60.0744C190.859 61.7692 189.486 63.1432 187.79 63.1432C186.095 63.1432 184.722 61.7692 184.722 60.0744C184.722 58.3796 186.095 57.0057 187.79 57.0057C189.486 57.0057 190.859 58.3796 190.859 60.0744Z",
    fill: "#5657D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.492 135.22C211.492 136.914 210.086 138.288 208.353 138.288C206.62 138.288 205.215 136.914 205.215 135.22C205.215 133.525 206.62 132.151 208.353 132.151C210.086 132.151 211.492 133.525 211.492 135.22Z",
    fill: "#02B1AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.455 47.2015C149.455 48.0488 148.768 48.7358 147.92 48.7358C147.073 48.7358 146.386 48.0488 146.386 47.2015C146.386 46.354 147.073 45.6671 147.92 45.6671C148.768 45.6671 149.455 46.354 149.455 47.2015Z",
    fill: "#FE9800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5708 140.83C49.5708 141.677 48.8839 142.364 48.0364 142.364C47.189 142.364 46.502 141.677 46.502 140.83C46.502 139.982 47.189 139.295 48.0364 139.295C48.8839 139.295 49.5708 139.982 49.5708 140.83Z",
    fill: "#FE9800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9349 171.384C34.9349 173.079 33.53 174.453 31.7969 174.453C30.0639 174.453 28.6589 173.079 28.6589 171.384C28.6589 169.689 30.0639 168.315 31.7969 168.315C33.53 168.315 34.9349 169.689 34.9349 171.384Z",
    fill: "#02B1AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.911 157.986C168.911 158.834 168.224 159.521 167.377 159.521C166.53 159.521 165.843 158.834 165.843 157.986C165.843 157.139 166.53 156.452 167.377 156.452C168.224 156.452 168.911 157.139 168.911 157.986Z",
    fill: "#B054DC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4425 39.6108C38.4425 41.3056 37.0375 42.6796 35.3044 42.6796C33.5714 42.6796 32.1664 41.3056 32.1664 39.6108C32.1664 37.916 33.5714 36.5421 35.3044 36.5421C37.0375 36.5421 38.4425 37.916 38.4425 39.6108Z",
    fill: "#FF00F5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0513 159.95L80.8975 111.154L134.667 129.948L126.285 185.298L76.9295 165.007C74.9356 164.188 73.7492 162.103 74.0513 159.95Z",
    fill: "#370B09"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.232 179.754C142.759 157.973 144.19 145.644 146.73 123.752L139.574 128.296L132.214 184.679L139.819 180.345C139.986 180.249 140.192 180.096 140.232 179.754Z",
    fill: "#F74848"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.738 186.125C127.511 186.125 119.947 182.407 119.947 182.407L128.738 124.786L139.982 126.645L132.213 184.68C132.213 184.68 129.965 186.125 128.738 186.125Z",
    fill: "url(#paint1_linear_1590_3987)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5265 106.466L81.5761 109.758C80.5764 110.341 80.7233 111.842 81.8164 112.215L133.496 129.542C135.397 130.192 137.488 129.947 139.191 128.874L146.44 124.31C146.924 124.008 146.835 123.276 146.293 123.099L93.9511 105.892C92.1441 105.298 90.1726 105.507 88.5265 106.466Z",
    fill: "url(#paint2_linear_1590_3987)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9987 138.043C102.87 136.31 106.935 137.842 109.079 141.465C111.221 145.087 110.631 149.429 107.759 151.162C107.284 151.45 106.775 151.646 106.248 151.76V160.515L97.6618 156.797L99.9267 149.405C99.4656 148.915 99.0448 148.358 98.6798 147.741C96.5368 144.119 97.1273 139.777 99.9987 138.043Z",
    fill: "url(#paint3_radial_1590_3987)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6657 156.541L100.808 149.002L105.919 150.654L106.499 160.224C106.514 160.476 106.261 160.656 106.032 160.556L97.8418 156.983C97.6729 156.91 97.5943 156.712 97.6657 156.541Z",
    fill: "#CD3C3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.283 137.272C103.154 135.539 107.22 137.07 109.363 140.693C111.506 144.316 110.915 148.658 108.043 150.391C107.4 150.78 106.698 151.003 105.97 151.077L106.5 159.813C106.515 160.065 106.261 160.245 106.032 160.144L97.8422 156.572C97.6732 156.498 97.5946 156.301 97.666 156.13L100.62 149.042C99.9976 148.46 99.4345 147.766 98.9639 146.971C96.8209 143.348 97.4113 139.005 100.283 137.272Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.283 137.271C97.4114 139.004 96.8209 143.346 98.9639 146.969C99.41 147.723 99.9393 148.387 100.524 148.949L110.389 143.166C110.177 142.33 109.837 141.493 109.363 140.692C107.22 137.069 103.154 135.537 100.283 137.271Z",
    fill: "#0D0F12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9366 113.725C81.5277 113.518 81.5277 113.105 81.5277 113.105L75.0488 160.796C75.0488 160.796 75.0488 161.622 75.4577 162.241C75.8666 162.861 76.8889 163.481 76.8889 163.481L83.3677 114.138C83.3677 114.138 82.3455 113.931 81.9366 113.725Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M136.58 125.086C136.3 126.101 133.516 126.206 130.361 125.319C127.207 124.432 124.876 122.89 125.156 121.874C125.436 120.858 128.22 120.754 131.375 121.641C134.529 122.528 136.86 124.07 136.58 125.086Z",
    fill: "#F24040",
    fillOpacity: 0.68
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.58 125.086C136.3 126.101 133.516 126.206 130.361 125.319C127.207 124.432 124.876 122.89 125.156 121.874C125.436 120.858 128.22 120.754 131.375 121.641C134.529 122.528 136.86 124.07 136.58 125.086Z",
    fill: "#370B09"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.415 113.107C101.135 114.122 98.3508 114.227 95.1963 113.34C92.0417 112.453 89.7112 110.91 89.991 109.895C90.2708 108.879 93.055 108.775 96.2096 109.662C99.3641 110.549 101.695 112.091 101.415 113.107Z",
    fill: "#F24040",
    fillOpacity: 0.68
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.415 113.107C101.135 114.122 98.3508 114.227 95.1963 113.34C92.0417 112.453 89.7112 110.91 89.991 109.895C90.2708 108.879 93.055 108.775 96.2096 109.662C99.3641 110.549 101.695 112.091 101.415 113.107Z",
    fill: "#370B09"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119.956 82.1359C126.422 83.1882 130.819 89.336 129.777 95.8674L125.627 121.894C125.627 121.894 126.285 123.753 130.169 124.785C134.053 125.818 135.934 124.785 135.934 124.785L140.273 97.5755C142.233 85.285 134.039 73.7109 121.934 71.5817L121.647 71.5331L119.539 71.1899C107.276 69.1942 95.7342 77.6183 93.7587 90.0055L90.5835 109.915L90.5505 110.122C90.5505 110.122 90.9151 111.361 94.3907 112.6C97.8663 113.839 100.792 113.426 100.792 113.426L100.858 113.013L104.255 91.7137C105.296 85.1823 111.382 80.7405 117.848 81.7927L119.956 82.1359Z",
    fill: "#0D0F12"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1590_3987",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.984 183.934) scale(72.8353 20.3585)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528846,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1590_3987",
    x1: 125.671,
    y1: 154.113,
    x2: 136.306,
    y2: 155.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#370B09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682139,
    stopColor: "#AC2322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F74848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1590_3987",
    x1: 82.3283,
    y1: 112.807,
    x2: 145.534,
    y2: 122.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC2322"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1590_3987",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.45337 5.90962 -9.25416 -3.81681 105.226 145.126)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C82828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/NoAccess.1b8c21992b8b3d54047ab358c26dbe8d.svg";
export { ForwardRef as ReactComponent };